type MediaPermissionName = 'camera' | 'microphone';
export type MediaPermissionQueryState = PermissionState | 'unsupported';

export interface MediaPermissionStatus {
  camera: MediaPermissionQueryState;
  microphone: MediaPermissionQueryState;
  isSupported: boolean;
  shouldShowInitialReminder: boolean;
}

const UNSUPPORTED_PERMISSION_STATE: MediaPermissionQueryState = 'unsupported';

const queryMediaPermissionState = async (name: MediaPermissionName): Promise<MediaPermissionQueryState> => {
  if (typeof navigator === 'undefined' || !navigator.permissions?.query) {
    return UNSUPPORTED_PERMISSION_STATE;
  }

  try {
    const status = await navigator.permissions.query({ name } as PermissionDescriptor);
    return status.state;
  } catch {
    return UNSUPPORTED_PERMISSION_STATE;
  }
};

export const getMediaPermissionStatus = async (): Promise<MediaPermissionStatus> => {
  const [camera, microphone] = await Promise.all([
    queryMediaPermissionState('camera'),
    queryMediaPermissionState('microphone'),
  ]);

  const knownStates = [camera, microphone].filter(
    (state): state is PermissionState => state !== UNSUPPORTED_PERMISSION_STATE
  );
  const isSupported = knownStates.length > 0;

  return {
    camera,
    microphone,
    isSupported,
    shouldShowInitialReminder: isSupported && knownStates.some(state => state !== 'granted'),
  };
};
